module.exports = __webpack_public_path__ + "img/mortar_pin.74f0696b.svg";